import { render } from "./UploadTotalDuration.vue?vue&type=template&id=fb982d32&ts=true"
import script from "./UploadTotalDuration.vue?vue&type=script&lang=ts"
export * from "./UploadTotalDuration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__